var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownArrowDarkBlue = function SvgDropdownArrowDarkBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#051016",
    fillRule: "evenodd",
    d: "M8.106 6.029 14.001.135l2.12 2.12-8.015 8.017L.09 2.256 2.212.135z",
    clipRule: "evenodd"
  })));
};
export default SvgDropdownArrowDarkBlue;